import React from 'react';
import L from 'leaflet';
import { LayerGroup } from 'react-leaflet';
import 'leaflet.markercluster';

const FUEL_GEOJSON_URL = `${process.env.PUBLIC_URL || ''}/static/fuel_stations_vietnam.geojson`;
const FUEL_PANE_NAME = 'fuel-overlay-pane';

let fuelGeoJsonCache = null;
let fuelGeoJsonRequest = null;

const loadFuelGeoJson = async () => {
  if (fuelGeoJsonCache) return fuelGeoJsonCache;

  if (!fuelGeoJsonRequest) {
    fuelGeoJsonRequest = fetch(FUEL_GEOJSON_URL)
      .then(async res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        fuelGeoJsonCache = data;
        return data;
      })
      .catch(err => {
        fuelGeoJsonRequest = null;
        throw err;
      });
  }

  return fuelGeoJsonRequest;
};

const fuelIcon = new L.Icon({
  iconUrl: '/static/iconSvg/gas.svg',
  iconSize: [28, 28],
  iconAnchor: [14, 28],
  popupAnchor: [0, -28],
});

const FuelStationsOverlayLayer = () => {
  const [geoJson, setGeoJson] = React.useState(fuelGeoJsonCache);
  const clusterRef = React.useRef(L.markerClusterGroup({
    chunkedLoading: true,
    removeOutsideVisibleBounds: true,
    iconCreateFunction: (cluster) => {
      const count = cluster.getChildCount();

      let size = 'small';
      if (count > 100) size = 'large';
      else if (count > 20) size = 'medium';

      const dimension =
        size === 'large' ? 50 :
          size === 'medium' ? 40 : 30;

      return L.divIcon({
        html: `<div style="
          width:${dimension}px;
          height:${dimension}px;
          border-radius:50%;
          background:rgba(51,136,255,0.25);
          border:2px solid #3388ff;
          display:flex;
          align-items:center;
          justify-content:center;
          font-weight:bold;
          color:#1a1a1a;
        ">
          ${count}
        </div>`,
        className: 'custom-cluster-icon',
        iconSize: L.point(dimension, dimension),
      });
    },
  }));

  const groupRef = React.useRef();

  // load data
  React.useEffect(() => {
    if (fuelGeoJsonCache) {
      setGeoJson(fuelGeoJsonCache);
      return;
    }

    loadFuelGeoJson().then(setGeoJson);
  }, []);

  // add cluster vào layer group (QUAN TRỌNG)
  React.useEffect(() => {
    if (!groupRef.current) return;

    const group = groupRef.current;
    const cluster = clusterRef.current;

    group.addLayer(cluster);

    return () => {
      group.removeLayer(cluster);
    };
  }, []);

  // render marker
  React.useEffect(() => {
    if (!geoJson) return;

    const cluster = clusterRef.current;
    cluster.clearLayers();

    geoJson.features.forEach(feature => {
      const [lng, lat] = feature.geometry.coordinates;
      const props = feature.properties;

      const marker = L.marker([lat, lng], { icon: fuelIcon });

      marker.bindPopup(`
        <div style="padding: 8px 12px;">
          <b>${props.name || 'Không tên'}</b>
        </div>
      `,
      {
        closeButton: false
      }
);

      cluster.addLayer(marker);
    });
  }, [geoJson]);

  return (
    <LayerGroup ref={groupRef} />
  );
};

export default React.memo(FuelStationsOverlayLayer);
